import { scaleLinear, ScaleLinear } from 'd3-scale'

export default class TrackContext implements CanvasDrawPath, CanvasRect, CanvasFillStrokeStyles {
    private ctx: CanvasRenderingContext2D
    private xScale: ScaleLinear
    private yScale: ScaleLinear
    private isVertical: boolean | null
    private width: number
    private height: number

    constructor(canvas: HTMLCanvasElement, xScale: any, isVertical: boolean | null) {
        this.width = canvas.width
        this.height = canvas.height
        this.isVertical = isVertical
        const yScale = scaleLinear([0, 1], isVertical ? [0, this.width] : [0, this.height])
        this.xScale = scaleLinear().domain(xScale.domain()).range(xScale.range()).clamp(false)
        this.yScale = yScale
        this.ctx = canvas.getContext('2d')
        // this.ctx.globalAlpha = 0.8
    }

    clear(): void {
        this.ctx.clearRect(0, 0, this.width, this.height)
    }

    getCtx(): CanvasRenderingContext2D {
        return this.ctx
    }

    set globalCompositeOperation(globalCompositeOperation: string) {
        this.ctx.globalCompositeOperation = globalCompositeOperation
    }

    set fillStyle(fillStyle: string) {
        this.ctx.fillStyle = fillStyle
    }

    fill(): void {
        this.ctx?.fill()
    }

    beginPath() {
        this.ctx?.beginPath()
    }

    createPattern(image: CanvasImageSource, repetition: string | null): CanvasPattern | null {
        return this.ctx?.createPattern(image, repetition)
    }

    fillRect(x: number, y: number, width: number, height: number) {
        const px = this.isVertical ? this.yScale(y) : this.xScale(x)
        const py = this.isVertical ? this.xScale(x) : this.yScale(y)
        const w = this.isVertical ? this.yScale(y + height) : this.xScale(x + width)
        const h = this.isVertical ? this.xScale(x + width) : this.yScale(y + height)
        this.ctx?.fillRect(px, py, w - px, h - py)
    }

    lineTo(x: number, y: number): void {}

    moveTo(x: number, y: number): void {}

    rect(x: number, y: number, w: number, h: number): void {}
}
